import React, { useEffect, useState, lazy } from 'react';
import { Route, Switch, Redirect, BrowserRouter } from 'react-router-dom';
import Cookies from 'universal-cookie';
import _ from 'lodash';
import { getData, onAuthStateChanged } from '../src/store/actions';
import quickTipsSeenService from './services/QuickTipsSeenService';
import './components/AdminScreen/admin.css';
import './styles/css/style.css';

import { signOut } from '../src/store/actions';
import SeniorsAtHomeRegistrationGuard from './components/SeniorsAtHome/SeniorsAtHomeRegistrationGuard';
const Login = lazy(() => import('./components/Login'));
const Signup = lazy(() => import('./components/Signup'));
const SeniorsAtHome = lazy(() => import('./components/SeniorsAtHome'));
const PeopleYouSupport = lazy(() => import('./components/SeniorsAtHome/PeopleYouSupport'));
const CareFocusArea = lazy(() => import('./components/SeniorsAtHome/CareFocusArea'));
const ReviewConsent = lazy(() => import('./components/SeniorsAtHome/ReviewConsent'));
const RegistrationSuccess = lazy(() => import('./components/SeniorsAtHome/RegistrationSuccess'));
const SeniorsAtHomePatientDashboard = lazy(() =>
  import('./components/SeniorsAtHome/PatientDashboard')
);
const SeniorsAtHomeSettings = lazy(() =>
  import('./components/SeniorsAtHome/Settings')
);
const SeniorsAtHomeCarePlan = lazy(() =>
  import('./components/SeniorsAtHome/CarePlan')
);
const SeniorsAtHomeAddFocusFlow = lazy(() =>
  import('./components/SeniorsAtHome/CarePlan/AddFocusFlow')
);
const SeniorsAtHomeEditCarerDetails = lazy(() =>
  import('./components/SeniorsAtHome/EditCarerDetails')
);
const SeniorsAtHomeVerifyMobile = lazy(() =>
  import('./components/SeniorsAtHome/VerifyMobile')
);
const SeniorsAtHomeManagePlan = lazy(() =>
  import('./components/SeniorsAtHome/ManagePlan')
);
const SeniorsAtHomeUpdatePayment = lazy(() =>
  import('./components/SeniorsAtHome/UpdatePayment')
);
const SeniorsAtHomeProgress = lazy(() =>
  import('./components/SeniorsAtHome/Progress')
);
const SeniorsAtHomeDocuments = lazy(() =>
  import('./components/SeniorsAtHome/Documents')
);
const SeniorsAtHomeAddPatientFlow = lazy(() =>
  import('./components/SeniorsAtHome/PatientDashboard/AddPatientFlow')
);
const Dashboard = lazy(() => import('./components/Dashboard'));
const AdminScreen = lazy(() => import('./components/AdminScreen'));
const ClinicList = lazy(() => import('./components/ClinicList'));
const EnterpriseClinicCreatePage = lazy(() => import('./components/Enterprise/EnterpriseClinicCreatePage'));
const AddCarePlanTemplates = lazy(() =>
  import('./components/AddCarePlanTemplates')
);
const AdminQuickTips = lazy(() => import('./components/AdminQuickTips'));
const Clinicdetail = lazy(() => import('./components/Clinicdetail'));
const Careplan = lazy(() => import('./components/Careplan'));
const HealthNotes = lazy(() => import('./components/HealthNotes'));
const Addcareplan = lazy(() => import('./components/Addcareplan'));
const AppointmentsCalendar = lazy(() => import('./components/Common/AppoinmentSchedule/AppointmentsCalendar'));
const AppointmentDetails = lazy(() => import('./components/Common/AppoinmentSchedule/AppointmentDetails'));
const Documents = lazy(() => import('./components/Documents'));
const Progress = lazy(() => import('./components/Progress'));
const VideoChatWrapper = lazy(() => import('./components/VideoChatWrapper'));
const TelehealthChatPage = lazy(() => import('./components/TelehealthChatPage'));
const Subscriptionplan = lazy(() => import('./components/Subscriptionplan'));
const Profile = lazy(() => import('./components/Profile'));
const PaymentStatus = lazy(() => import('./components/Common/PaymentStatus'));
const PaymentCancelled = lazy(() => import('./components/Common/PaymentCancelled'));
const ResetPassword = lazy(() => import('./components/ResetPassword'));
const CareBuddySetup = lazy(() => import('./components/CareBuddySetup'));
const Loader = lazy(() => import('./components/Loader'));
const Notification = lazy(() => import('./Notification'));
const Layout = lazy(() => import('./Layout'));
const FallPreventionChartView = lazy(() => import('./components/Dashboard/FallPreventionChartView'));
const ManageProviderDirectory = lazy(() => import('./components/ProviderDirectory/Manage'));
const PublicDirectory = lazy(() => import('./components/PublicDirectory'));
const WorkWithUsForm = lazy(() => import('./components/PublicDirectory/WorkWithUsForm'));
const WorkWithUsAdmin = lazy(() => import('./components/WorkWithUsAdmin'));
const ProviderRegistration = lazy(() => import('./components/ProviderRegistration'));
const AppointmentDeepLink = lazy(() => import('./components/Common/AppointmentDeepLink'));

const cookie = new Cookies();

const initialState = {
  authenticated: null,
  isLoading: true,
  role: null,
  isLogged: false,
  user: {},
};

const token = localStorage.getItem('user');
const QUICK_TIPS_SEEN_KEY = 'quickTipsSeen';

const mergeAndStoreQuickTipsSeen = (contextsFromDb) => {
  try {
    const existingRaw = localStorage.getItem(QUICK_TIPS_SEEN_KEY);
    const existing = existingRaw ? JSON.parse(existingRaw) : [];
    const base = Array.isArray(existing) ? existing : [];
    const incoming = Array.isArray(contextsFromDb) ? contextsFromDb : [];
    const merged = Array.from(new Set([...base, ...incoming]));
    localStorage.setItem(QUICK_TIPS_SEEN_KEY, JSON.stringify(merged));
  } catch (e) {
    // ignore
  }
};

const allRoutes = [
  {
    id: 'login',
    component: Login,
    path: '/login',
    isAuth: true,
    exact: true,
    default: true,
    redirect: '/dashboard',
  },
  {
    id: 'signup',
    component: Signup,
    path: '/signup',
    isAuth: true,
    exact: true,
    default: true,
    redirect: '/dashboard',
  },
  {
    id: 'seniorsathome',
    component: SeniorsAtHome,
    path: '/seniorsathome',
    isAuth: true,
    exact: true,
    default: true,
    redirect: '/dashboard',
  },
  {
    id: 'seniorsathome-people-you-support',
    component: SeniorsAtHomeRegistrationGuard,
    guardedComponent: PeopleYouSupport,
    path: '/seniorsathome/people-you-support',
    isAuth: false,
    exact: true,
    default: true,
    role: 'user',
  },
  {
    id: 'seniorsathome-care-focus-area',
    component: SeniorsAtHomeRegistrationGuard,
    guardedComponent: CareFocusArea,
    path: '/seniorsathome/care-focus-area',
    isAuth: false,
    exact: true,
    default: true,
    role: 'user',
  },
  {
    id: 'seniorsathome-review-consent',
    component: SeniorsAtHomeRegistrationGuard,
    guardedComponent: ReviewConsent,
    path: '/seniorsathome/review-consent',
    isAuth: false,
    exact: true,
    default: true,
    role: 'user',
  },
  {
    id: 'seniorsathome-registration-successful',
    component: SeniorsAtHomeRegistrationGuard,
    guardedComponent: RegistrationSuccess,
    path: '/seniorsathome/registration-successful',
    isAuth: false,
    exact: true,
    default: true,
    role: 'user',
  },
  {
    id: 'seniorsathome_patient_dashboard',
    component: SeniorsAtHomePatientDashboard,
    path: '/seniorsathome/dashboard',
    isAuth: false,
    exact: true,
    requiredSession: true,
    role: 'user',
    redirect: '/login',
  },
  {
    id: 'seniorsathome_add_patient',
    component: SeniorsAtHomeAddPatientFlow,
    path: '/seniorsathome/dashboard/add-patient',
    isAuth: false,
    exact: true,
    requiredSession: true,
    role: 'user',
    redirect: '/login',
  },
  {
    id: 'seniorsathome_settings',
    component: SeniorsAtHomeSettings,
    path: '/seniorsathome/dashboard/settings',
    isAuth: false,
    exact: true,
    requiredSession: true,
    role: 'user',
    redirect: '/login',
  },
  {
    id: 'seniorsathome_edit_carer_details',
    component: SeniorsAtHomeEditCarerDetails,
    path: '/seniorsathome/dashboard/settings/edit-carer-details',
    isAuth: false,
    exact: true,
    requiredSession: true,
    role: 'user',
    redirect: '/login',
  },
  {
    id: 'seniorsathome_verify_mobile',
    component: SeniorsAtHomeVerifyMobile,
    path: '/seniorsathome/dashboard/settings/verify-mobile',
    isAuth: false,
    exact: true,
    requiredSession: true,
    role: 'user',
    redirect: '/login',
  },
  {
    id: 'seniorsathome_manage_plan',
    component: SeniorsAtHomeManagePlan,
    path: '/seniorsathome/dashboard/settings/manage-plan',
    isAuth: false,
    exact: true,
    requiredSession: true,
    role: 'user',
    redirect: '/login',
  },
  {
    id: 'seniorsathome_update_payment',
    component: SeniorsAtHomeUpdatePayment,
    path: '/seniorsathome/dashboard/settings/update-payment',
    isAuth: false,
    exact: true,
    requiredSession: true,
    role: 'user',
    redirect: '/login',
  },
  {
    id: 'seniorsathome_care_plan',
    component: SeniorsAtHomeCarePlan,
    path: '/seniorsathome/dashboard/patients/:patientId/care-plan',
    isAuth: false,
    exact: true,
    requiredSession: true,
    role: 'user',
    redirect: '/login',
  },
  {
    id: 'seniorsathome_add_focus',
    component: SeniorsAtHomeAddFocusFlow,
    path: '/seniorsathome/dashboard/patients/:patientId/care-plan/add-focus',
    isAuth: false,
    exact: false,
    requiredSession: true,
    role: 'user',
    redirect: '/login',
  },
  {
    id: 'seniorsathome_progress',
    component: SeniorsAtHomeProgress,
    path: '/seniorsathome/dashboard/patients/:patientId/progress',
    isAuth: false,
    exact: true,
    requiredSession: true,
    role: 'user',
    redirect: '/login',
  },
  {
    id: 'seniorsathome_documents',
    component: SeniorsAtHomeDocuments,
    path: '/seniorsathome/dashboard/patients/:patientId/documents',
    isAuth: false,
    exact: true,
    requiredSession: true,
    role: 'user',
    redirect: '/login',
  },
  {
    id: 'reset_password',
    component: ResetPassword,
    path: '/resetPassword',
    isAuth: true,
    exact: true,
    default: true,
    redirect: '/dashboard',
  },
  {
    id: 'care_buddy_setup',
    component: CareBuddySetup,
    path: '/care-buddy-setup',
    isAuth: true,
    exact: true,
    default: true,
    redirect: '/dashboard',
  },
  {
    id: 'reset_password_admin',
    component: ResetPassword,
    path: '/admin/resetPassword',
    isAuth: true,
    exact: true,
    default: true,
    isAdminAuthRoute: true,
    redirect: '/admin/dashboard',
  },
  {
    id: 'admin_login',
    requiredSession: true,
    component: Login,
    path: '/admin',
    isAuth: true,
    default: true,
    isAdminAuthRoute: true,
    exact: true,
    redirect: '/admin/dashboard',
  },
  {
    id: 'user_profile',
    requiredSession: true,
    component: Profile,
    path: '/profile/:id',
    isAuth: false,
    exact: true,
    role: 'user',
    redirect: '/login',
  },
  {
    id: 'admin_profile',
    requiredSession: true,
    component: Profile,
    path: '/admin/profile',
    isAuth: false,
    exact: true,
    role: 'admin',
    redirect: '/admin',
  },
  {
    id: 'user_dashboard',
    requiredSession: true,
    component: Dashboard,
    path: '/dashboard',
    isAuth: false,
    exact: true,
    role: 'user',
    redirect: '/login',
  },
  {
    id: 'admin_dashboard',
    requiredSession: true,
    component: AdminScreen,
    path: '/admin/dashboard',
    isAuth: false,
    exact: true,
    role: 'admin',
    redirect: '/admin',
    isAdminAuthRoute: true,
  },
  {
    id: 'admin_quicktips',
    requiredSession: true,
    component: AdminQuickTips,
    path: '/admin/quicktips',
    isAuth: false,
    exact: true,
    role: 'admin',
    redirect: '/admin',
    isAdminAuthRoute: true,
  },
  {
    id: 'admin_patient_list',
    requiredSession: true,
    component: Dashboard,
    path: '/admin/patients',
    isAuth: false,
    exact: true,
    role: 'admin',
    redirect: '/admin',
    isAdminAuthRoute: true,
  },
  {
    id: 'admin_single_patient_careplan',
    requiredSession: true,
    component: Careplan,
    path: '/admin/careplan/:id',
    isAuth: false,
    exact: true,
    role: 'admin',
    redirect: '/admin',
    isAdminAuthRoute: true,
  },
  {
    id: 'admin_single_patient_progress',
    requiredSession: true,
    component: Progress,
    path: '/admin/progress/:id',
    isAuth: false,
    exact: true,
    role: 'admin',
    redirect: '/admin',
    isAdminAuthRoute: true,
  },
  {
    id: 'admin_single_patient_documents',
    requiredSession: true,
    component: Documents,
    path: '/admin/documents/:id',
    isAuth: false,
    exact: true,
    role: 'admin',
    redirect: '/admin',
    isAdminAuthRoute: true,
  },
  {
    id: 'admin_single_patient_health_notes',
    requiredSession: true,
    component: HealthNotes,
    path: '/admin/healthnotes/:id',
    isAuth: false,
    exact: true,
    role: 'admin',
    redirect: '/admin',
    isAdminAuthRoute: true,
  },
  {
    id: 'admin_clinic_details',
    requiredSession: true,
    component: Clinicdetail,
    path: '/admin/clinicdetail/:id',
    isAuth: false,
    exact: true,
    role: 'admin',
    redirect: '/admin',
    isAdminAuthRoute: true,
  },
  {
    id: 'admin_clinic_list',
    requiredSession: true,
    component: ClinicList,
    path: '/admin/clinics',
    isAuth: false,
    exact: true,
    role: 'admin',
    redirect: '/admin',
  },
  {
    id: 'admin_create_clinic',
    requiredSession: true,
    component: EnterpriseClinicCreatePage,
    path: '/admin/clinics/new',
    isAuth: false,
    exact: true,
    role: 'admin',
    redirect: '/admin',
    isAdminAuthRoute: true,
  },
  {
    id: 'add_care_plan_templates',
    requiredSession: true,
    component: AddCarePlanTemplates,
    path: '/admin/care-plan-templates/:id',
    isAuth: false,
    exact: true,
    role: 'admin',
    redirect: '/admin',
  },
  {
    id: 'new_add_care_plan_templates',
    requiredSession: true,
    component: AddCarePlanTemplates,
    path: '/care-plan-templates',
    isAuth: false,
    exact: true,
    role: 'admin',
    redirect: '/admin',
  },
  {
    id: 'admin_add_care_plan',
    requiredSession: true,
    component: Addcareplan,
    path: '/admin/addcareplan/:id',
    isAuth: false,
    exact: true,
    role: 'admin',
    redirect: '/admin',
    isAdminAuthRoute: true,
  },
  {
    id: 'clinic_details',
    requiredSession: true,
    component: Clinicdetail,
    path: '/clinicdetail',
    isAuth: false,
    exact: true,
    role: 'user',
    redirect: '/login',
  },
  {
    id: 'manage_provider_directory',
    requiredSession: true,
    component: ManageProviderDirectory,
    path: '/clinic/provider-directory',
    isAuth: false,
    exact: true,
    role: 'user',
    redirect: '/login',
  },
  {
    id: 'work_with_us_applications',
    requiredSession: true,
    component: WorkWithUsAdmin,
    path: '/clinic/work-with-us-applications',
    isAuth: false,
    exact: true,
    role: 'user',
    redirect: '/login',
  },
  {
    id: 'public_provider_directory',
    component: PublicDirectory,
    path: '/provider-directory/embed/:clinicId',
    isPublic: true,
    isAuth: false,
    exact: true,
  },
  {
    id: 'work_with_us',
    component: WorkWithUsForm,
    path: '/work-with-us/:clinicId',
    isPublic: true,
    isAuth: false,
    exact: true,
  },
  {
    id: 'provider_registration',
    component: ProviderRegistration,
    path: '/provider-registration',
    isPublic: true,
    isAuth: false,
    exact: true,
  },
  {
    id: 'appointment',
    requiredSession: true,
    component: AppointmentsCalendar,
    path: '/appointment',
    isAuth: false,
    exact: true,
    role: 'user',
    redirect: '/login',
  },
  {
    id: 'appointment_deeplink',
    component: AppointmentDeepLink,
    path: '/telehealth-appointment',
    isPublic: true,
    isAuth: false,
    exact: true,
  },
  {
    id: 'appointment_details',
    requiredSession: true,
    component: AppointmentDetails,
    path: '/appointment-details/:appointmentId',
    isAuth: false,
    exact: true,
    role: 'user',
    redirect: '/login',
  },
  {
    id: 'care_plan',
    requiredSession: true,
    component: Careplan,
    path: '/careplan/:id',
    exact: true,
    role: 'user',
    redirect: '/login',
  },
  {
    id: 'health_notes',
    requiredSession: true,
    component: HealthNotes,
    path: '/healthnotes/:id/(condition)?/:conditionId?',
    exact: true,
    role: 'user',
    redirect: '/login',
  },
  {
    id: 'add_care_plan',
    requiredSession: true,
    component: Addcareplan,
    path: '/addcareplan/:id',
    exact: true,
    role: 'user',
    redirect: '/login',
  },
  {
    id: 'telehealth',
    requiredSession: true,
    component: VideoChatWrapper,
    path: '/telehealth/appointment/:appointmentId',
    exact: true,
    role: 'user',
    redirect: '/login',
  },
  {
    id: 'telehealth_task',
    requiredSession: true,
    component: VideoChatWrapper,
    path: '/telehealth/:id',
    exact: true,
    role: 'user',
    redirect: '/login',
  },
  {
    id: 'telehealth-chat',
    requiredSession: true,
    component: TelehealthChatPage,
    path: '/telehealth-chat/:taskId',
    exact: true,
    role: 'user',
    redirect: '/login',
  },
  {
    id: 'payment_cancelled',
    requiredSession: true,
    component: PaymentCancelled,
    path: '/checkout/cancelled',
    exact: true,
    role: 'user',
    redirect: '/login',
  },
  {
    id: 'payment_status',
    requiredSession: true,
    component: PaymentStatus,
    path: '/checkout/:status',
    exact: true,
    role: 'user',
    redirect: '/login',
  },
  {
    id: 'documents',
    requiredSession: true,
    component: Documents,
    path: '/documents/:id',
    exact: true,
    role: 'user',
    redirect: '/login',
  },
  {
    id: 'user_progress',
    requiredSession: true,
    component: Progress,
    path: '/progress/:id',
    exact: true,
    role: 'user',
    redirect: '/login',
  },
  {
    id: 'subscription_plan',
    requiredSession: true,
    component: Subscriptionplan,
    path: '/subscriptionplan',
    exact: true,
    role: 'user',
    redirect: '/login',
  },
  {
    id: 'fall_prevention_chart',
    component: FallPreventionChartView,
    path: '/fall-prevention-chart/:patientId',
    isAuth: true,
    exact: true,
    default: true,
  },
];

const App = ({ adminData, ...props }) => {
  const [user, setUser] = useState(initialState);
  const [loaderDone, setLoaderDone] = useState(false);
  const [routesReady, setRoutesReady] = useState(false);

  useEffect(() => {
    if (!user.isLoading && !routesReady) {
      setRoutesReady(true);
    }
  }, [user.isLoading, routesReady]);

  useEffect(() => {
    const timeout = setTimeout(() => setRoutesReady(true), 5000);
    return () => clearTimeout(timeout);
  }, []);
  setTimeout(() => {
    if (!adminData) {
      signOut();
    } else {
      localStorage.clear();
      window.location.reload();
    }
  }, 16200000);

  const handleAdminUser = () => {
    const userData = JSON.parse(adminData);
    setUser({
      authenticated: !!userData?.user_id,
      isLoading: false,
      isAdmin: userData?.isAdmin,
      role: userData?.role,
      isLogged: !!userData?.user_id,
      user: userData,
    });
  };

  const handleUser = async () => {
    try {
      setUser({
        ...user,
        isLoading: true,
      });

      const authenticated = await new Promise((resolve, reject) => {
        onAuthStateChanged((err, authenticated) => {
          if (!err) {
            resolve(authenticated);
          } else {
            reject(err);
          }
        });
      });

      if (!authenticated) {
        setUser({ ...initialState, isLoading: false });
        return;
      }

      if (authenticated.emailVerified) {
        const mfaVerified =
          cookie.get('otp_verified', { path: '/' }) === 'true' ||
          localStorage.getItem('mfa_verified') === 'true';

        if (!mfaVerified) {
          cookie.remove('otp_verified', { path: '/' });
          setUser({ ...initialState, isLoading: false });
          return;
        }

        if (
          !_.isEmpty(cookie.get('user', { path: '/' })) &&
          authenticated.emailVerified
        ) {
          try {
            const contexts = await quickTipsSeenService.getSeenContexts(authenticated?.uid);
            mergeAndStoreQuickTipsSeen(contexts);
          } catch (e) {
          }

          setUser({
            user: cookie.get('user', { path: '/' }) || {},
            authenticated: authenticated?.uid,
            isLoading: false,
            role: 'user',
            isLogged: true,
            emailVerified: authenticated.emailVerified,
          });
        } else {
          await getData('users', authenticated?.uid, async (err, userRes) => {
            delete userRes.tokens;
            await cookie.set('user', userRes || {}, { path: '/' });
            console.log('user after login2 --- -', userRes, authenticated);

            try {
              const contexts = await quickTipsSeenService.getSeenContexts(authenticated?.uid);
              mergeAndStoreQuickTipsSeen(contexts);
            } catch (e) {
            }

            setUser({
              user: userRes ? userRes : {},
              authenticated: authenticated?.uid,
              isLoading: false,
              role: 'user',
              isLogged: true,
              emailVerified: authenticated.emailVerified,
            });
          });
        }
      } else {
        setUser({ ...initialState, isLoading: false });
        signOut();
      }
    } catch (error) {
      console.error('Error in handleUser:', error);
      setUser({ ...initialState, isLoading: false });
    }
  };

  useEffect(() => {
    adminData ? handleAdminUser() : handleUser();
  }, [adminData, token]);

  const roleWiseAccess = (access) => {
    const publicRoutes = allRoutes.filter((val) => val.isPublic);
    if (!user.role) {
      return [...publicRoutes, ...allRoutes.filter((val) => val.default)];
    } else {
      const cloneData = allRoutes.filter((val) => val?.role === access);
      const roleRoutes = cloneData.length
        ? cloneData
        : allRoutes.filter((val) => val.default);
      return [...publicRoutes, ...roleRoutes];
    }
  };

  const handleIsLoggedIn = () => {
    // Trust in-memory auth state only to avoid MFA bypass on refresh
    return !!user.isLogged && !!user.role;
  };
  return (
    <div className="app-layout" {...props}>
      <Notification />
      <BrowserRouter>
        {!loaderDone && (
          <Loader
            isReady={routesReady}
            onComplete={() => setLoaderDone(true)}
          />
        )}
        {!user.isLoading && (
          <Switch>
            {roleWiseAccess(user.role).map(
              (
                {
                  requiredSession,
                  redirect,
                  isAdminAuthRoute,
                  isPublic,
                  id,
                  isAuth,
                  component: Component,
                  ...extraData
                },
                index
              ) => {
                return (
                  <Route
                    key={index}
                    {...extraData}
                    render={(props) => (
                      <Layout
                        user={user}
                        component={Component}
                        {...props}
                        {...{
                          requiredSession,
                          isAuth,
                          redirect,
                          isAdminAuthRoute,
                          isPublic,
                          id,
                          ...extraData,
                        }}
                      />
                    )}
                  />
                );
              }
            )}
            {handleIsLoggedIn() && user.role ? (
              <Route
                path="*"
                render={() => {
                  if (user.role === 'admin') {
                    return <Redirect to="/admin/dashboard" />;
                  }

                  const clinic = cookie.get('clinic', { path: '/' });
                  const isCarer =
                    (user.user && !!user.user.isCarerMode) ||
                    (clinic && !!clinic.isCarerMode);

                  return (
                    <Redirect
                      to={isCarer ? '/seniorsathome/dashboard' : '/dashboard'}
                    />
                  );
                }}
              />
            ) : (
              <Redirect to="/login" />
            )}
          </Switch>
        )}
      </BrowserRouter>
    </div>
  );
};

export default App;
